import React from "react";

const Moth = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Moth</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg table-responsive"
        style={{ textAlign: "justify" }}
      >
        <table className="table table-striped table-bordered">
          <thead className="text-center">
            <tr>
              <th>Seed Rate</th>
              <th>Sowing Time</th>
              <th>Irrigation</th>
              <th>Maturity Time</th>
              <th>Characterstics</th>
              <th>Average Yield</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="6">RMO - 40 [Released in 02.09.1994]</td>
            </tr>
            <tr>
              <td>4-5 kgs per acre.</td>
              <td>Start of rain to 15th August</td>
              <td>One irrigation is enough at the time of flowering.</td>
              <td>62-65 days.</td>
              <td>
                Straight standing variety. Better crop for less rainfed areas.
                Intermittent and heavy rains are harmful. Generally, Moth is
                grown in infertile sandy soil, but slightly fertile soil is
                suitable for this crop.
              </td>
              <td>2.5-3.5 quintals per acre.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Moth;
